// eslint-disable-next-line import/no-anonymous-default-export
export default {
    translation: {
        next_btn: "Continue",
        logout: "Logout",
        back_btn: "Back",

        errors: {
            invalid_password: "Invalid password. It must be 6-20 characters, contain a capital letter, a lowercase letter and a number.",
            hear_us_error: "Please select where you heard about us.",
            email_validation: "Email must contain the \"@\" symbol",
            required_field: "This field is required.",
            conf_email_error: "Email and Confirm Email do not match",
            conf_password_error: "Password and Confirm Password do not match",
            canadian_email_error: "We cannot accept Canadian email addresses",
            enter_characters: "Enter no more than 11 characters.",
            tax_enter_characters: "Enter no more than 10 characters.",
            conf_ssn_error: "SSN and Confirm SSN do not match",
            conf_tax_error: "Tax ID and Confirm Tax ID do not match",
            years_old_error: "You must be at least 18 years old.",
            custodial_year: "You must be under 18 years of age",
            exp_date_error: "Must be later than the current date.",
            exp_earlier_date_error: "Must be earlier than the current date.",
            exp_issue_date_error: "Must be later than the issue date.",
            select_country_error: "Please select a country.",
            liquid_assets_error: "Liquid networth must be equal to or less than networth",
            low_assets_error: "Liquid assets selection is too low for this account",
            low_income_error: "Annual income selection is too low for this account",
            low_worth_error: "Net worth selection is too low for this account",
            invalid_signature: "Your signature must match your name on the application as",
            indicate_error: "Ownership percentages must add to 100%",
            liquid_error: "If your liquid net worth is under $20,000 we cannot approve you for margin. Please select a cash account.",
            valid_date: "Please enter a valid date in MM/DD/YYYY format.",
            main_user_ssn: "Cannot be the same as the SSN of the main user",
            zip_code_format: "Zip code is Invalid. Must be NNNNN or NNNNN-NNNN",
            required_file_upload: "File upload is required",
            or: "or",
            trusted_success: "Trusted contact saved successfully.",
            missing_id: "Application ID is missing.",
            trusted_failed: "Failed to save trusted contact.",
            server_error: "Server error while saving data."
        },

        register: {
            user_registration: "OPENING A CHOICETRADE ACCOUNT IS EASY!",
            for_limited: "There is a $100 minimum to open a ChoiceTrade account. If you apply for a margin account, there is a $2,000 minimum.",
            username: "Username",
            email: "Email",
            password: "Password",
            confirm_password: "Confirm Password",
            hear_us: "Where did you hear about us?",
            citizen_status: "Citizenship Status",
            type_account: "Select the type of account you wish to open.",
            individual: "Individual",
            joint_account_type: "Joint Account",
            custodial: "Custodial",
            ira: "IRA",
            specialty_account_type: "Specialty Account",
            already_sign_in: "Already started your application? Sign in.",
            important_info: "To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you open an account, we will ask for your name, address, date of birth and other information that will allow us to identify you. We may also ask to see your driver’s license or other identifying documents.",
            security_disclaimer: "U.S. securities products and services through ChoiceTrade, a broker regulated in the U.S. ChoiceTrade does not recommend any security or investment strategy. The web site you came to ChoiceTrade from and ChoiceTrade are separate companies. Non-ChoiceTrade web content and posts do not reflect the views of ChoiceTrade and have not been reviewed by ChoiceTrade for completeness or accuracy.",
            big_saving_text: "Find out how you can unlock BIG SAVINGS by completing your application.  It will only take a few minutes."
        },

        personal: {
            welcome: "Welcome",
            welcome_pls: "Please continue your application below. ",
            personal_info: "Personal Information",
            title: "Title",
            mr: "MR.",
            ms: "MS.",
            mrs: "MRS.",
            dr: "DR.",
            first_name: "First Name",
            last_name: "Last Name",
            date_of_birth: "DATE OF BIRTH MM/DD/YYYY",
            ssn: "SSN XXX-XX-XXXX",
            confirm_ssn: "Confirm SSN XXX-XX-XXXX",
            mobile_phone: "Mobile phone (country code and number)",
            marital_status: "Marital Status",
            single: "Single",
            married: "Married",
            divorced: "Divorced",
            widow: "Widow",
            iden_type: "Identification type",
            state_dl: "State DL",
            state_id: "State ID",
            national_id: "National ID",
            passport: "Passport",
            iden_number: "Identification number",
            issue_date: "Issue date MM/DD/YYYY",
            expiration_date: "Expiration date MM/DD/YYYY",
            permanent_address: "Permanent Address",
            address2: "Address 2",
            city: "City",
            select_country: "Select country",
            zip_code: "Zip code",
            select_state: "Select state",
            different_address: "MY MAILING ADDRESS IS DIFFERENT",
            mailing_address: "Mailing Address",
            mailing_address2: "Mailing Address 2",
            mailing_city: "City",
            mailing_country: "Select Country",
            mailing_zip_code: "Zip Code",
            mailing_state: "Select State",
            identification: "Identification",
            street_number_name: "STREET NUMBER AND NAME",
            issue_exp_date: "My ID does not have issue or expiry date",
            take_photo: "Now please take a moment to submit a copy of your government-issued ID"
        },

        financial: {
            thanks: "Thanks",
            need_financial_info: "NOW WE NEED YOUR FINANCIAL INFORMATION",
            financial_info: "Financial Information",
            employment_status: "EMPLOYMENT STATUS",
            employed: "Employed",
            self_employed: "Self Employed",
            retired: "Retired",
            homemaker: "Homemaker",
            student: "Student",
            unemployed: "Unemployed",
            school_name: "School Name",
            occupation: "OCCUPATION",
            accounting: "Accounting",
            agriculture: "Agriculture",
            banking_and_finance: "Banking and Finance",
            clerical: "Clerical",
            construction: "Construction",
            consulting: "Consulting",
            customer_service: "Customer Service - Call Center",
            education: "Education",
            engineer: "Engineer",
            government: "Government",
            healthcare: "Healthcare",
            hotel_restaurant: "Hotel and Restaurant",
            information: "Information Technology",
            internet: "Internet and E-commerce",
            legal: "Legal",
            management_executive: "Management and Executive",
            manufacturing: "Manufacturing",
            marketing: "Marketing",
            media: "Media - Journalism",
            non_profit: "Non-profit",
            real_estate: "Real Estate",
            retail: "Retail",
            sales: "Sales",
            science: "Science",
            security: "Security",
            sports: "Sports",
            travel: "Travel and Tourism",
            wholesale: "Wholesale",
            company_name: "Company Name",
            business_address: "Business Address",
            city: "City",
            select_country: "Select Country",
            zip_code: "Zip Code",
            select_state: "Select State",
            source_of_income: "PRIMARY SOURCE OF INCOME",
            job: "Job",
            personal_saving: "Personal Savings",
            spouse: "Spouse/Parent",
            inheritance: "Inheritance",
            investment: "Investment",
            retirement_plan: "Retirement Plan",
            real_estate_investment: "Real estate investment",
            stock_retirement: "Stock retirement annuity",
            family_wealth: 'Family wealth',
            passive_income: "Passive income",
            royalties: "Royalties",
            property_income: "Property income",
            portfolio_income: "Portfolio income",
            other: "Other",
            source_of_wealth: "PRIMARY SOURCE OF WEALTH",
            personal_income_saving: "Personal Income/Savings",
            sale_of_business: "Sale of Business",
            annual_income: "ANNUAL INCOME",
            liquid_assets: "LIQUID ASSETS",
            over: "Over",
            net_worth: "NET WORTH",
            sold_business_name: "SOLD BUSINESS NAME",
            sale_amount: "SALE AMOUNT",
            date_sold: "DATE SOLD"
        },

        affiliation: {
            welcome: "Welcome",
            affiliated: "Next, we need to know if you are affiliated with any of the following.",
            affiliation_information: "Affiliation Information",
            yes: "YES",
            no: "NO",
            aff_company_name: "Company Name",
            your_position: "Your Position",
            aff_person_name: "NAME OF AFFILIATED PERSON",
            agent_list: "PLEASE LIST AGENT FOR SERVICE OF PROCESS",
            financial_regulator: "Please scan and email a copy of the document showing your membership with your country's financial regulator to service@choicetrade.com",
            political_organization: "Please provide the names of that official and immediate family members (including former spouses) and the related foreign political organization?",
            name: "Name",
            organization: "ORGANIZATIONS",
            ownership_disclosure: "Ownership Disclosure",
            ownership_disclosed: "Under rule 14b-1(c) of the Securities Exchange Act. We are required to disclose to an issuer the name, address and security position of our customer who are benificial owner of that issuer's securities unless the customer objects. Please check here if you do NOT want ownership disclosed.",
            privacy_and_policy: "I have read and agree with ChoiceTrade ",
            privacy_policy: "Privacy Policy",
            are_member: "Are you or a member of your household a director, 10% shareholder, or officer of a publicly traded company?",
            NFA_or_CFTC: "Are you or a member of your household affiliated or employed by a registered broker/dealer, insurance company, bank, investment adviser doing business in the U.S. or any United States exchange or self-regulatory organization, including the SEC, FINRA, NFA or CFTC?",
            foreign_shell: "Is this application being submitted on behalf of a foreign shell bank?",
            owner_affiliated: "Is this account owner affiliated with a foreign shell bank?",
            owner_offer: "Does the account owner offer services to a foreign shell bank?",
            bankruptcy_proceeding: "Have you ever been the subject of a bankruptcy proceeding, receivership, or similar action?",
            commodity_account: "Have you ever been in a legal dispute, arbitration, or reparations action related to a securities or commodity account?",
            commodity_firm: "Have you ever closed, or left dormant, an account with an unpaid balance at a securities or commodity firm?",
            business_with_you: "Have you or will you receive funds from any person or entity who is not an owner of this account that will be used to fund this account during the life of the account? (If you are going to fund the account at any time with someone else's money then we are sorry we cannot do business with you.",
            financial_institution: "Is this application being submitted on behalf of a Foreign Financial Institution? ",
            close_associate: "Is this application being submitted on behalf of a current or former senior political figure (see Definition) or an immediate family member or close associate?",
        },

        account: {
            welcome: "Welcome",
            option_trading: "Now consider the option-trading and margin-trading capabilities you wish to have for your account.  Your option-trading experience should match your desired level of option trading.  If you have no experience, you will not be able to attain the higher levels of option trading.",
            account_privileges: "Account Privileges",
            account_profile: "Select an account profile",
            cash_margin: "CashMargin",
            cash: "Cash",
            day_trade1: "Do you intend to",
            day_trade2: "daytrade",
            day_trade3: "in this account",
            cash_margin_accounts: "CashMargin accounts have additional privileges over Cash Accounts. Roll over each account profile for details. (Only Cash Accounts are allowed for Custodial Accounts and IRAs)",
            specify_trading_level: "Please specify your desired option trading level for this account. Most levels of option trading capability require a speculative investment objective with the exception of Covered Calls. Please indicate your desired degree of option trading below.",
            option_trading_level: "Specific Option Objective and Requested Option Trading Level",
            choose_one: "Choose one:",
            level1: "Objective: Income : Level 1:Write Covered Calls",
            level2: "Objective: Speculation : Level 2:Level 1+ Buy calls and puts",
            level3: "Objective: Speculation : Level 3:Level 2 + Debit Spreads",
            level4: "Objective: Speculation : Level 4:Level 3 + Credit Spreads",
            level5: "Objective: Speculation : Level 5:Level 4 + Uncovered Equity Options",
            level6: "I do not wish to add options trading capability to this account",
        },

        experience: {
            welcome: "Welcome",
            investment_experience: "Now please let us know about your investment experience and investment objectives.",
            previous_investment: "Previous Investment Experience",
            stocks: "Stocks:",
            year: "YEAR",
            average_size: "Average size",
            average_number: "Average number",
            options: "Options:",
            investment_objective: "Investment Objective",
            speculative_activity: "Please click on the investment objective that is most important for you. The first two objectives may be disabled because of the type of account and features that you have selected earlier in the application process. For instance, investing in penny stocks, using margin, or trading options (other than option level 1) are speculative in nature and require a high risk tolerance. If your investment objective is less risk tolerant, and you wish to make those selections, you will have to go back and uncheck those features.",
            objective: "Objective:",
            risk_tolerance: "Investment Objective: Income. Risk Tolerance: Moderate. Time Horizon: Less than 5 Years (An investment objective of Income indicates that you seek to generate income from investments and are interested in investments that have historically demonstrated a lesser risk of loss of principal value than for the other objectives. Some examples of typical investments might include high quality, short-term fixed income products and covered call options. You are solely responsible for determining that each investment you make is consistent with your investment objectives and risk profile. ChoiceTrade will not monitor this for you.)",
            capital_appreciation: "Investment Objective: Capital Appreciation. Risk Tolerance :Speculation. Time Horizon: Less than 5 Years (An investment objective of Capital Appreciation indicates that you seek to grow the principal value of your investments over time and are willing to invest in securities that have historically demonstrated an above average degree of risk of loss of principal value to pursue this objective. Some examples of typical investments might include common stocks, lower quality, medium-term fixed income products, equity mutual funds and index funds. You are solely responsible for determining that each investment you make is consistent with your investment objectives and risk profile. ChoiceTrade will not monitor this for you. If you choose this objective you will not be able to buy OTC(penny) stocks or options.)",
            time_horizon: "Investment Objective: Speculation. Risk Tolerance: Speculation. Time Horizon. Less than 5 Years (An investment objective of Speculation indicates you seek a significant increase in the principal value of your investments and are willing to accept a corresponding greater degree of risk by investing in securities that have historically demonstrated a high degree of risk of loss of principal value to pursue this objective, sometimes in excess of your principal investment. You may seek to take advantage of short-term trading opportunities, which may involve establishing and liquidating positions quickly. Some examples of typical investments might include lower quality, long-term fixed income products, initial public offerings, volatile or low priced common stocks, the purchase or sale of put or call options, spreads, straddles and/or combinations on equities or indexes, and the use of short-term or day trading strategies. You are solely responsible for determining that each investment you make is consistent with your investment objectives and risk profile. ChoiceTrade will not monitor this for you. If you wish to trade penny stocks or options (other than covered calls), or if you wish to day trade (any type of security) this is the only objective we will accept before your account is permitted to trade in these speculative securities.)",
            document_delivery: "Document Delivery",
            additional_fees: "I agree to receive the following documents by email rather than postal mail (there are additional fees to receive paper documents by mail)",
            trade_conf_email: "Trade Confirmations by email.",
            account_statement_email: "Account Statements by email.",
            proxy_statement_email: "Proxy Statements by email.",
            prospectuses_email: "Prospectuses by email.",
            tax_document_email: "Tax documents by email.",
        },

        conditions: {
            thanks: "Thanks",
            terms_condition: "Now we need you to review and agree to some terms and conditions to each agreement below. (Please open each tab and check the box)",
            financial_information: "Disclosures",
            customer_agreement: "Customer Agreement",
            conditions_governing: "I represent that I have read, understand and agree to the Terms and Conditions governing this account as contained in the",
            conditions_governing2: "I agree to be bound by such Terms and Conditions as currently in effect and as may be amended from time to time without prior notice to me. I warrant that all the information I have entered on my application is correct to the best of my knowledge and belief. If there is a change in the future, I agree to promptly notify ChoiceTrade in writing.",
            arbitration_agreement: "I UNDERSTAND THAT THIS ACCOUNT IS GOVERNED BY AN ARBITRATION AGREEMENT WHICH IS SET FORTH IN PARAGRAPHS 18 AND 19 OF THE CUSTOMER AGREEMENT. I ACKNOWLEDGE RECEIPT  OF THE ARBITRATION AGREEMENT AND THE CUSTOMER ACCOUNT AGREEMENT GOVERNING MY ACCOUNT. I acknowledge that I have read and understand the Active Trading Risk Disclosure Statement, the Margin Disclosure Statement and the ChoiceTrade Privacy Statement. I understand and acknowledge that (i) this account application is not made pursuant to any solicitation, (ii) ChoiceTrade is not affiliated with or an agent of its clearing firm, and (iii) nothing herein is an offer or solicitation of any security, product or service in any jurisdiction where their offer or sale would be contrary to local law or regulation.I acknowledge that ChoiceTrade does not give investment, tax, legal or accounting advice with respect to the potential value or suitability of a particular security or investment strategy.",
            fee_acknowledgement: "Fee acknowledgement",
            service_fee: "Some platforms involve a monthly Service Fee. I acknowledge and agree to pay the Service Fee by authorizing ChoiceTrade to debit my account. I acknowledge that a finder's fee may be paid pursuant to agreement.",
            margin_agreement1: "Margin Agreement (Velox)",
            margin_agreement: "Margin Agreement",
            margin_agreement2: "Margin Agreement (Curvature)",
            margin_terms: "I AGREE TO ALL TERMS OF THE MARGIN SUPPLEMENT. I ACKNOWLEDGE THAT MY MARGIN ACCOUNT SECURITIES MAY BE BORROWED BY ME OR LOANED TO OTHERS.",
            margin_risk: "Margin Risk Disclosure Statement",
            options_agreement: "OPTIONS AGREEMENT",
            any_material_change: "I AGREE TO ADVISE CHOICETRADE OF ANY MATERIAL CHANGE IN MY FINANCIAL STATUS AND/OR INVESTMENT OBJECTIVES. I AGREE TO ALL TERMS OF THE OPTIONS SUPPLEMENT. I ACKNOWLEDGE THAT I HAVE READ THE DISCLOSURE DOCUMENT AT THE FOLLOWING LINK, “CHARACTERISTICS AND RISKS OF STANDARDIZED OPTIONS” AND AM AWARE OF THE SPECIAL RISKS INHERENT IN OPTIONS TRADING.",
            option_disclosures: "Option Disclosures",
            options_supplement: "Options Supplement",
            taxpayer_id_number: "Certification of Taxpayer ID number (Substitute W-9) (please skip this section if you are not a U.S. Person for Tax Purposes)",
            notified_irs: "Check this box if you have been notified by the IRS that you are exempt from backup withholding. (please skip this section if it does not apply to you or if you are not a U.S. Person for Tax Purposes)",
            penalty_of_perjury: "Under penalty of perjury I certify that:",
            number_1: "1. The number shown on this application is my correct taxpayer identification number (or I am waiting for a number to be issued to me) and",
            number_2: "2. I am not subject to backup withholding because (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service(IRS) that I am subject to backup withholding as a result of a failure to report  all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding (does not apply to real estate transactions, mortgage interest paid, the acquisition or abandonment of secured property, contributions to an individual retirement account (IRA), and payments other than interest and dividends.)",
            number_3: "3. I am a U.S. person (including a U.S. resident alien). Certification Instructions -- You must cross out item 2 above if you have been notified by the IRS, that you are currently subject to backup withholding because you have failed to report all interest and dividends on your tax return.)",
            clearing_authorization: "CLEARING FIRM AUTHORIZATION",
            client_auth_condition: "Our clearing firm provides access to view various reports.  Please check this box to authorize them to provide this service to you.",
            agreew8_heading: "Form W8-BEN Certification of Tax Status",
            agreew8_text: "I agree with the above certification. I acknowledge that I must make the declaration contained in the perjury statement of the IRS form W8-BEN and that I make this declaration by my signature below. I hereby agree to submit my form W8-BEN electronically and permit ChoiceTrade to share it with its clearing firm.",
            agreew8_text2: "I certify that I am not a US citizen, US resident alien or other US person for US tax purposes, and I am submitting the applicable Form W-8 BEN with this form to certify my foreign status and, if applicable, claim tax treaty benefits.",
            w8_form: "W8-Form",
            alpa1: "I have read, understood, and agree to be bound by Alpaca Securities LLC and ChoiceTrade account terms, and all other terms, disclosures and disclaimers applicable to me, as referenced in the",
            alpa2: ". I also acknowledge that the",
            alpa3: "contains a pre-dispute arbitration clause in Section 43.",
            alpa4: " By clicking 'I agree' I understand that I am signing this agreement electronically, and that my electronic signature will have the same effect as physically signing and returning the Application.",
            alpa_heading: "Alpaca Customer Agreement",
            finder_heading: "Foreign Finder Agreement",
            finder_text1: "The undersigned customer acknowledges and agrees to each of the following:",
            finder_text2: "I am/we are not U.S. citizens or residents. If applying on behalf of an entity, the entity is not a U.S. entity, nor is it domiciled in the U.S.",
            finder_text3: "ChoiceTrade has not solicited me to open an account with ChoiceTrade. In order for me to conduct business at ChoiceTrade, ChoiceTrade is not required to be registered in my jurisdiction",
            finder_text4: "My account is subject to a compensation arrangement under which ChoiceTrade will pay non-U.S. finders",
            finder_text5: "(“Finders”) transaction-related compensation. My commission schedule is ChoiceTrade’s regular schedule unless also noted below. The Finders are not brokers, employees or agents of ChoiceTrade, and I/we will not deal with the Finders regarding my/our business with ChoiceTrade. Other than finder relationships, ChoiceTrade does not have any affiliation with Finders. I/we will deal directly with ChoiceTrade regarding all aspects of my/our ChoiceTrade account.",
            finder_text6: "By signing this application, I/we understand, acknowledge and agree with the foregoing effective the date of the application.",
            privacy: "Privacy",
            trading_header: "Trading Agreement",
            trading_text1: "I have read and agree to the",
            trading_text2: "Trading Authorization Agreement",
            trading_text3: "by filling out this application and signing it.",
            foreignfinder: "ChoiceTrade will pay a Non-U.S. finder, Red Information Technology Ltd. a transaction-related compensation of one-half of the profit on ChoiceTrade’s portion of the commissions and margin interest that I pay. This ratio is subject to change."
        },

        review: {
            next: "Next,",
            review_info: "please review your information.",
            click_here: "Click Here",
            print_page: "to Print Page.",
            review_app: "Review Application",
            registration: "Registration:",
            edit: "Edit",
            citizen_status: "Citizenship Status:",
            account_type: "Type of Account:",
            personal_info: "Personal Info:",
            title: "Title:",
            first_name: "First Name:",
            last_name: "Last Name:",
            date_of_birth: "Date of Birth:",
            ssn: "SSN:",
            marital_status: "Marital Status:",
            permanent_address: "Permanent Address:",
            address2: "Address 2:",
            city: "City:",
            country: "Country:",
            zip_code: "Zip/Postal Code:",
            employment: "Employment:",
            employment_status: "Employment Status:",
            contact_info: "Contact Info:",
            phone: "Day Time Phone:",
            email: "Email:",
            financial_info: "Financial Info:",
            source_of_income: "Primary Source of Income:",
            annual_income: "Annual Income:",
            liquid_assets: "Liquid Assets:",
            net_worth: "Net Worth:",
            account_privileges: "Account Privileges:",
            investment_account_type: "Investment Account Type:",
            investment: "Investment Account Type:",
            mailing_address: "Mailing Address:",
            perm_address: "Same as Permanent Address:",
            mailing_address2: "Address 2:",
            mailing_city: "City:",
            mailing_state: "State:",
            mailing_country: "Country:",
            mailing_zip_code: "Zip/Postal Code:",
            previous_investment: "Previous Investment Experience:",
            stocks: "Stocks:",
            year: "Years:",
            average_size: "Average size:",
            average_number: "Average Number of Transactions/Year:",
            options: "Options:",
            investment_objective: "Investment Objectives:",
            investment_experience_text: "Investment Objective: Speculation. Risk Tolerance: Speculation. Time Horizon. Less than 5 Years",
            specific_option_level: "Specific Option Objective and Requested Option Trading Level:"
        },

        signature: {
            sign_and_submit: "Sign and Submit",
            signature: "Signature:",
            primary_account: "Primary Account Owner",
            signature_line: "Please sign the document by typing your first name and last name on the signature line.",
            arbitration_agreement: "I UNDERSTAND THAT THIS ACCOUNT IS GOVERNED BY AN ARBITRATION AGREEMENT WHICH IS SET FORTH IN PARAGRAPHS 18 AND 19 OF THE CUSTOMER AGREEMENT. I ACKNOWLEDGE RECEIPT OF THE ARBITRATION AGREEMENT AND THE CUSTOMER ACCOUNT AGREEMENT GOVERNING MY ACCOUNT.",
            terms_and_conditions: "I represent that I have read, understand and agree to the Terms and Conditions governing this account as contained in the Customer Agreement. I agree to be bound by such Terms and Conditions as currently in effect and as may be amended from time to time without prior notice to me. I warrant that all the information I have entered on my application is correct to the best of my knowledge and belief. If there is a change in the future, I agree to promptly notify ChoiceTrade in writing. I acknowledge that I have read and understand the ",
            risk_disclosure_statement: "Active Trading Risk Disclosure Statement, the Margin Disclosure Statement and the ChoiceTrade Privacy Statement.",
            service_fee: "I understand and acknowledge that (i) this account application is not made pursuant to any solicitation, (ii) ChoiceTrade is not affiliated with or an agent of its clearing firm, and (iii) nothing herein is an offer or solicitation of any security, product or service in any jurisdiction where their offer or sale would be contrary to local law or regulation. I acknowledge that ChoiceTrade does not give investment, tax, legal or accounting advice with respect to the potential value or suitability of a particular security or investment strategy. Some platforms involve a monthly Service Fee.",
        },

        welcome_to: {
            welcome_to: "Welcome to ChoiceTrade",
            upload: "UPLOAD",
            complete_app: "Congratulations! Your application is complete. For now, here is an application confirmation number for reference: ",
            complete_app_number: "(This is not your account number).",
            complete_app_continue: "Once your application is approved, you will be issued an account number, login information and be provided with funding instructions by email. Please do not initiate funding before you have an account number.",
            complete_app_continue1: "If you have not already done so, please submit a copy of your current government-issued ID like a driver’s license, passport or national ID card – this document must contain your name, photo and date of birth.",
            complete_app_continue2: "You can click the CAPTURE IMAGE button below to take and submit a clear photo of your document with your device's camera or you can UPLOAD the file to us if you already have it saved in your device.  (You may also email it to ",
            mail_to: "service@choicetrade.com",
            complete_app_continue3: "separately and we will attach it to your application. If you send via email, be sure to send from the email address you have provided in your account application.)",
            capture_image: "capture image",
            doc_verification: "Document Verification",
            picture_id: "We need a picture of your ID",
            confirm_doc: "Please position your document so that it fills the frame of your camera screen.",
            retake_photo: "Retake photo",
            photo_text: "Is the photo clear and not cut off?"
        },

        welcome_back: {
            welcome_back: "Welcome back!",
            click_below: "Click below to resume an application already in progress.",
            app_in_progress: "You have application(s) completed or in progress. Click on any one to continue.",
            individual: "Individual",
            second_app: "Submit a Second Application",
            delete: "Delete",
            account: "Account",
            started: "started on",
            completed: "You have completed",
            completed_of: "of 7 steps",
            first_name: "First Name",
            last_name: "Last Name",
            email: "Email",
            phone: "Phone number",
            saved: "Save Trusted Contact",
            saving: "Saving...",
            trusted_heading: "Trusted Contact",
            add_contact: "Add Trusted Contact",
            trusted_text: "A trusted contact is a person you authorize your financial firm to contact in limited circumstances, such as if there is a concern about activity in your account and they have been unable to get in touch with you. A trusted contact may be a family member, attorney, accountant or another third-party who you believe would respect your privacy and know how to handle the responsibility. The trusted person should be 18 years old or older."
        },

        logout_modal: {
            logout_text: "If you are done with application click Ok, to stay on page click Cancel.",
            ok: "OK",
            cancel: "CANCEL"
        },

        login: {
            login: "LOGIN",
            enter_email: "ENTER EMAIL",
            enter_password: "ENTER PASSWORD",
            cancel: "CANCEL",
            forget_password: "Forgot your Password?",
            forgot_password: "Forgot Password",
            retrieve_password: "To retrieve your word, enter your email address below",
            send_message: "We have sent the password reset link to your email",
            acc_not_found: "Account not found!",
            user_not_found: "User not found!",
            email: "Email",
            new_password: "New Password",
            confirm_new_password: "Confirm New Password",
        },

        modals: {
            ind_modal: {
                joint1: "JOINT TENANTS WITH RIGHTS OF SURVIVORSHIP",
                joint2: "JOINT TENANTS IN COMMON",
                joint3: "JOINT WITH TENANTS BY THE ENTIRETY",
                joint4: "JOINT COMMUNITY PROPERTY",
            },

            ira_modal: {
                ira: "Now please provide us the information about the beneficiary for your IRA account.",
                close: "Close",
                ira1: "Traditional IRA",
                ira2: "ROTH IRA",
                ira3: "SIMPLE IRA",
                ira4: "Coverdale IRA",
                ira5: "SEP IRA",
                ira6: "Rollover IRA"
            },

            special_modal: {
                corporate: "CORPORATE",
                non_profit: "NON PROFIT",
                invest_club: "INVESTMENT CLUB",
                limited_company: "LIMITED LIABILITY COMPANY",
                partnership: "PARTNERSHIP",
                partnership_corp: "Partnership",
                trust: "TRUST",
                c_corporation: "C-Corporation",
                s_corporation: "S-Corporation",
                trust_ssn: "Does the Trust use the trustee's SSN?",
                trust_id: " Does the Trust have its own tax ID number?",
                close: "Close",
                member: "MEMBER"
            }
        },

        specialty: {
            trust_company_name: "Trust, Company or Organization Name",
            country_of: "Country of Incorporation/Organization",
            for_accounts: "FOR ENTITY ACCOUNTS AND IRAS, WE NEED ADDITIONAL INFORMATION ON TRUSTEES, AUTHORIZED SIGNERS OR BENEFICIARIES.",
            middle_name: "MIDDLE NAME",
            entity_role: "ENTITY ROLE",
            president: "President",
            treasurer: "Treasurer",
            vice_president: "Vice President",
            secretary: "Secretary",
            add_signer: "I need to add another Authorized Signer"
        },

        custodial: {
            thanks: "Thanks",
            provide_info: "NOW PLEASE PROVIDE US THE INFORMATION ABOUT THE MINOR FOR WHOM YOU ARE SETTING UP THIS ACCOUNT."
        },


        joint: {
            thanks: "THANK YOU",
            joint_info: "JOINT OWNER PERSONAL INFORMATION",
            provide_joint_info: "NEXT, PLEASE PROVIDE INFORMATION FOR EACH OF THE JOINT OWNER ON THE ACCOUNT.",
            joint_account_spouse: "Is the the joint account owner the spouse of the primary account holder?",
            joint_primary_address: "Is Primary address the same as Account Owner's?",
            yes: "Yes",
            no: "No",
            evening_phone: "Evening Phone",
            are_you_member: "Are you or a member of your household affiliated or employed by a registered broker/dealer, insurance company, bank, investment adviser doing business in the U.S. or any United States exchange or self-regulatory organization, including the SEC, FINRA, NFA or CFTC?",
            indicate: "PLEASE INDICATE % OF OWNERSHIP FOR EACH INDIVIDUAL BELOW"
        },

        tooltip: {
            country_tooltip: "If your country is not listed, we will not be able to accept your application. Please email us at service@choicetrade.com if you have questions. Canadian citizens living in Canada are not allowed to open an account with a US broker, per Canadian law.",
            state_tooltip: "ChoiceTrade is registered in the 50 U.S. states and D.C. but not in U.S. territories. We regret that we cannot accept applicants from Puerto Rico, Guam, the U.S. Virgin Islands and other U.S. territories.",
            country_tooltip_message: "Why isn't my country listed?",
            state_tooltip_message: "Why isn't my state listed?",
            cash_margin_tooltip: "A margin account is one that has loan privileges. In a margin account you will get the sales proceeds back right away for a new purchase; in a cash account you may not. A margin account is the only account type in which you can short a stock. Please read our Margin Disclosure. Since margin is a riskier account type than cash, if your investment objective points to safety, your margin application may not be approved and you should consider applying for a cash account.  You must fund a margin account with at least $2,000 and maintain it at this level or above.",
            cash_tooltip: "A cash account is the simplest account privilege. By definition, any account that does not have margin privileges is a cash account. In a cash account, if you buy a stock on a given day and sell it before the buy settles (settlement date is one business day from date of buy), then the proceeds from the sale will not be available for a new purchase until one business day after the sale. Therefore, you may decide, for this reason alone, that a margin account is the right account for you."
        },

        about: {
            about_us: "About Us",
            about_us1: "Introducing ChoiceTrade, the premier destination for active traders, self-directed investors, and stock market enthusiasts alike. Founded with a commitment to empowering investors of all levels, ChoiceTrade offers a seamless and intuitive web-based trading platform designed to simplify the trading experience.",
            about_us2: "At ChoiceTrade, we understand that navigating the complexities of the stock market can be daunting. That's why we've crafted a platform that prioritizes clarity and ease of use, eliminating unnecessary clutter and complications. Whether you're a seasoned trader or just dipping your toes into the world of investing, ChoiceTrade provides the tools and resources you need to make informed decisions with confidence.",
            about_us3: "Our mission is simple. to provide our customers with a true \"choice\" in their trading journey. With ChoiceTrade, you can trust that the benefits, convenience, and service far exceed the commissions you'll pay, no matter your level of trading sophistication.",
            about_us4: "Join us at ChoiceTrade and experience the difference for yourself. Take control of your financial future with a platform that puts your needs first. Welcome to a new era of trading excellence. Welcome to ChoiceTrade.",
        }
    },
}